import { Box } from '../../../primitives';
import { styled } from '../../../theme';

export const Circle = styled(Box)`
	border-radius: 500px;
	background-color: #fff;
	display: flex;
	justify-content: center;
	align-items: center;
`;
